import round from './round';
import breakCountdown from './break';
import { randomCombo, classicCombo, burnoutCombo, jabCrossBuildCombo, jabCrossRandomCombo, hookUppercutBuildCombo, hookUppercutRandomCombo, carewCombo, gapCombo, powerCombo } from './../boxing/combos';
import { getRandomItems } from './../utils/array';

const boxingMovesCountdown = (roundNumber, exercises, setState, finishedCallback) => {
  return round(
    3, // minutes
    30, // timeUnit
    `Round ${roundNumber}`,
    exercises,
    setState,
    finishedCallback
  )
};

const boxingCountdown = (roundNumber, exercises, setState, finishedCallback) => {
  return [
    breakCountdown(`Round ${roundNumber}`, setState, finishedCallback),
    boxingMovesCountdown(roundNumber, exercises, setState, finishedCallback)
  ]
}

const multipleBoxingCountdowns = (number, setState, finishedCallback) => {
  const combos = getRandomItems([
          randomCombo(),
          randomCombo(),
          randomCombo(false),
          randomCombo(false),
          randomCombo(true, false),
          randomCombo(true, false),
          classicCombo(),
          jabCrossBuildCombo(),
          jabCrossRandomCombo(),
          carewCombo(),
          hookUppercutRandomCombo(),
          hookUppercutBuildCombo(),
          gapCombo(),
          powerCombo(),
          burnoutCombo()
        ], number);

  return combos.map((combo, index) => boxingCountdown(index + 1, combo, setState, finishedCallback));
}

export default multipleBoxingCountdowns;
